<section class="process-section py-5" id="process">
  <div class="container">
    <div class="text-center mb-5">
      <h2 class="section-title">{{ i18n.getTranslation('process.title') }}</h2>
      <p class="section-subtitle">{{ i18n.getTranslation('process.subtitle') }}</p>
    </div>

    <div class="row justify-content-center">
      <div class="col-12">
        <div class="process-steps">
          <div class="process-step" *ngFor="let step of processSteps; let i = index">
            <div class="step-number">{{ i + 1 }}</div>
            <div class="step-icon">
              <i [class]="step.icon"></i>
            </div>
            <div class="step-content">
              <h4 class="step-title">{{ step.title }}</h4>
              <p class="step-description">{{ step.description }}</p>
            </div>
            <div class="step-connector" *ngIf="i < processSteps.length - 1"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
